import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import { Container, Col, Row } from "react-bootstrap";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import URLstateContext from "../../../provider/CommonContext";
import "../../CompanySnapshot/CompanyChart/CompanyChart.css";
import CompanyAbout from './../CompanyAbout/CompanyAbout';
import { Rings } from 'react-loader-spinner';

function CompanyChart(props, ref) {
  let getExchange = props.exchange;
  let getCoCode = props.coCode;

  if (getExchange == "") { getExchange = "NSE"; }
  const [data, setData] = useState([]);
  const [chartdata, setchartData] = useState([]);
  const [chartperiod, setchartperiod] = useState('1D');
  const { BaseURL } = useContext(URLstateContext);
  let getData, getchartData, indicator;
  useImperativeHandle(ref, () => ({
    chnageexchnage: (excgh, cocode) => {
      setchartperiod('1D');
      if (cocode != "") {
        const getUrlchart = BaseURL + "Company-Chart/";
        fetch(`${getUrlchart}/${excgh}/${cocode}/1D`)
          .then((response) => response.json())
          .then((data) => {
            getchartData = data.data;
            setchartData(getchartData);
            //console.log("getchartData",getchartData)

          })
          .catch((error) => {
            //console.log("not found the api");
          });

        const getUrl = BaseURL + "GetQuoteDetails";
        fetch(`${getUrl}/${cocode}/${excgh}`)
          .then((response) => response.json())
          .then((data) => {
            getData = data.data;
            setData(getData);
            // console.log(getData);
          })
          .catch((error) => {
            //  console.log("not found the api");
          });
      }
    }
  }));

  useLayoutEffect(() => {
    let root = am5.Root.new("chartdiv");

    root.setThemes([
      am5themes_Animated.new(root)
    ]);

    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panY: false,

      layout: root.verticalLayout
    }));

    indicator = root.container.children.push(am5.Container.new(root, {
      width: am5.p100,
      height: am5.p100,
      layer: 1000,
      background: am5.Rectangle.new(root, {
        fill: am5.color(0xffffff),
        fillOpacity: 0.7
      })
    }));

    indicator.children.push(am5.Label.new(root, {
      text: "Loading...",
      fontSize: 25,
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: am5.p50
    }));


    chart.get("colors").set("colors", [
      am5.color(0x024FA1),

    ]);

    // Create Y-axis
    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      maxDeviation: 1,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    // Create X-Axis
    let baseI = chartperiod === "1D" ? { timeUnit: "minute", count: 1 } : { timeUnit: "day", count: 1 };


    var xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
    xRenderer.labels.template.setAll({
      rotation: -60,
      centerY: am5.p50,
      centerX: am5.p100,
      paddingRight: 15
    });
    let xAxis = chart.xAxes.push(am5xy.DateAxis.new(root, {
      //groupData: true,
      maxDeviation: 0.5,
      renderer: xRenderer,
      baseInterval: baseI,

    }));

    // xAxis.get("dateFormats")["day"] = "MM/dd";
    // xAxis.get("periodChangeDateFormats")["day"] = "MMMM";

    // Generate random data
    function generateChartData() {

      let chartData = [];

      // current date
      //let firstDate = new Date();
      // now set 500 minutes back
      //firstDate.setMinutes(firstDate.getDate() - 500, 0, 0);

      // and generate 500 data items
      //console.log("chart period:"+chartperiod);
      // console.log("chartdata",JSON.stringify(chartdata));



      if (chartdata != null && chartdata != []) {
        for (var i = 0; i < chartdata.length; i++) {
          let newDate = new Date(chartdata[i].upd_Date);


          chartData.push({
            time: newDate.getTime(),
            price: chartdata[i].price
          });
        }
      }
      else {

      }
      return chartData;


    }

    // console.log("ddddd:"+JSON.stringify(generateChartData()));
    let data = generateChartData();



    //let lbltxt = "[bold]{name}[/]\n{valueX.formatDate()}: {valueY}";

    let lbltxt = chartperiod === "1D" ? "[bold] ₹ {valueY} | {valueX.formatDate('HH:mm')}" : "[bold] ₹ {valueY} | {valueX.formatDate('dd-MMM-yyyy')}";

    // Create series
    let series = chart.series.push(am5xy.LineSeries.new(root, {
      name: "Series",
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "price",
      valueXField: "time",
      tooltip: am5.Tooltip.new(root, {
        pointerOrientation: "horizontal",
        labelText: lbltxt
      })
    }));

    series.strokes.template.set("strokeWidth", 2);
    series.fills.template.setAll({
      visible: true,
      fillOpacity: 0.4
    });
    if (chartperiod === "1D" || chartperiod === "5D") {
      series.bullets.push(function (root) {
        return am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 3,
            fill: series.get("fill"),
            fill: am5.color(0x024FA1),
          })
        });
      });
    }

    series.set("fill", am5.color(0x80D962)); // set Series color to red



    series.data.setAll(data);



    series.fills.template.set("fillGradient", am5.LinearGradient.new(root, {
      stops: [{
        opacity: 0
      }, {
        opacity: 1
      }],
      rotation: 90
    }));

    // Add cursor
    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: xAxis
    }));

    xAxis.set("tooltip", am5.Tooltip.new(root, {}));

    yAxis.set("tooltip", am5.Tooltip.new(root, {}));
    indicator.hide();

    return () => {
      root.dispose();
    };
  }, [chartdata]);


  // useEffect(() => {

  //   if (props.coCode != "" && props.exchange != "") {
  //     const getUrl = BaseURL + "GetQuoteDetails";
  //     fetch(`${getUrl}/${getCoCode}/${getExchange}`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         getData = data.data;
  //         setData(getData);

  //         // console.log("aaaaaaa", getData);
  //       })
  //       .catch((error) => {
  //         //console.log("not found the api");
  //       });
  //     //console.log("ABCD");
  //     const getUrlchart = BaseURL + "Company-Chart";
  //     fetch(`${getUrlchart}/${getExchange}/${getCoCode}/${chartperiod}`)
  //       .then((response) => response.json())
  //       .then((data) => {
  //         getchartData = data.data;
  //         setchartData(getchartData);
  //         // console.log("chartdata:"+JSON.stringify(getchartData));
  //       })
  //       .catch((error) => {
  //         // console.log("not found the api");
  //       });
  //   }


  // }, [props.coCode, props.exchange]);

  useEffect(() => {
  if (props.coCode !== "" && props.exchange !== "") {
    const getUrl = BaseURL + "GetQuoteDetails";
    fetch(`${getUrl}/${getCoCode}/${getExchange}`)
      .then((response) => response.json())
      .then((data) => {
        getData = data.data;
        setData(getData);
      })
      .catch((error) => {
        // Handle error
      });

    // Fetch chart data based on the selected period
    const getUrlchart = BaseURL + "Company-Chart";
    fetch(`${getUrlchart}/${getExchange}/${getCoCode}/${chartperiod}`)
      .then((response) => response.json())
      .then((data) => {
        getchartData = data.data;
        setchartData(getchartData);
      })
      .catch((error) => {
        // Handle error
      });
  }
}, [props.coCode, props.exchange, chartperiod]); // Include chartperiod in dependency array






  const clickchartperiodHandler = (priod) => {
    setchartperiod(priod);

    const getUrlchart = BaseURL + "Company-Chart/";

    fetch(`${getUrlchart}/${getExchange}/${getCoCode}/${priod}`)
      .then((response) => response.json())
      .then((data) => {
        getchartData = data.data;
        setchartData(getchartData);

      })
      .catch((error) => {
        // console.log("not found the api");
      });

  }


  return (
    <>
      <section className="company-chart-section compChart">

        <Container className="add-border table-box1">

          <Row>

            <Col md={12} lg={5}>
              <div className="company-chart-data ">
                {(data === null) ? <div className="errorDiv"><h4 className="errormsgCom">No Data Available !!!</h4></div> : ''}
                {data != null && data.map((eachData) => (
                  <ul>

                    <li>
                      <span>Open</span>
                      <h4> {(eachData.openprice != null) ? eachData.openprice.toFixed(2) : eachData.openprice = 0}</h4>
                      {/* <h4>{eachData.openprice.toFixed(2)}</h4> */}
                    </li>

                    <li>
                      <span>Price</span>
                      <h4> {(eachData.price != null) ? eachData.price.toFixed(2) : eachData.price = 0}</h4>
                      {/* <h4>{eachData.price.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>Volume</span>
                      <h4> {(eachData.volume != null) ? eachData.volume.toFixed(2) : eachData.volume = 0}</h4>
                      {/* <h4>{eachData.volume.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>Today's high</span>
                      <h4> {
                        (eachData.highprice != null) ? eachData.highprice.toFixed(2) : eachData.highprice = 0
                      }</h4>
                      {/* <h4>{eachData.highprice.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>52 week high</span>
                      <h4> {(eachData.high52wk != null) ? eachData.high52wk.toFixed(2) : eachData.high52wk = 0}</h4>
                      {/* <h4>{eachData.high52wk.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>Prev. Close</span>
                      <h4> {
                        (eachData.oldprice != null) ? eachData.oldprice.toFixed(2) : eachData.oldprice = 0
                      }</h4>
                      {/* <h4>{eachData.oldprice.toFixed(2)}</h4> */}
                    </li>

                    <li>
                      <span>ISIN</span>
                      <h4> {(eachData.isin != null) ? eachData.isin : eachData.isin = 0}</h4>
                      {/* <h4>{eachData.isin}</h4> */}
                    </li>
                    <li>
                      <span>Value</span>
                      <h4> {(eachData.value != null) ? eachData.value.toFixed(2) : eachData.value = 0}</h4>
                      {/* <h4>{eachData.value.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>Today's low</span>
                      <h4> {(eachData.lowprice != null) ? eachData.lowprice.toFixed(2) : eachData.value = 0}</h4>
                      {/* <h4>{eachData.lowprice.toFixed(2)}</h4> */}
                    </li>
                    <li>
                      <span>52 week low</span>
                      <h4> {(eachData.low52wk != null) ? eachData.low52wk.toFixed(2) : eachData.low52wk = 0}</h4>
                      {/* <h4>{eachData.low52wk.toFixed(2)}</h4> */}
                    </li>
                  </ul>
                ))}
              </div>
            </Col>
            <Col md={12} lg={7}>
              <CompanyAbout exchange={getExchange} coCode={getCoCode} />

            </Col>

          </Row>
        </Container>
        <Container className="table-box">
          <Row>
            <Col md={12}>
              <div>
                <ul className="day-data scheme">
                  <li className={chartperiod === "1D" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('1D')}>1 Day</li>
                  <li className={chartperiod === "5D" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('5D')}>1 Week</li>
                  <li className={chartperiod === "1M" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('1M')}>1 Month</li>
                  <li className={chartperiod === "3M" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('3M')}>3 Month</li>
                  <li className={chartperiod === "1Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('1Y')}>1 Year</li>
                  <li className={chartperiod === "3Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('3Y')}>3 Year</li>
                  <li className={chartperiod === "5Y" ? "liwidth active" : "liwidth"} onClick={() => clickchartperiodHandler('5Y')}>5 Year</li>
                </ul>
              </div>
              {(chartdata === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
              <div id="chartdiv" style={{ width: "100%", height: "325px" }}></div>

            </Col>
          </Row>
        </Container>

      </section>
    </>
  );
}

export default React.forwardRef(CompanyChart);
